// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"614":"8b17aa99","624":"13c19bcd","918":"26a8bd36","993":"0e97ae83"}[chunkId] + ".chunk.css";
};